import { ele } from "cables-shared-client";

export default class Cookies
{
    /**
     * Creates a cookie
     */
    createCookie(name, value, days)
    {
        let expires = "";
        if (days)
        {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/; secure=true; SameSite=lax";
    }

    /**
     * Reads a cookie
     */
    readCookie(name)
    {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++)
        {
            let c = ca[i];
            while (c.charAt(0) === " ") c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * Shows the cookie warning
     */
    showWarning()
    {
        if (!this.readCookie("accepted"))
        {
            const cookieWarning = ele.byId("cookie-warning");
            if (cookieWarning)
            {
                ele.show(cookieWarning);
                cookieWarning.addEventListener("click", () =>
                {
                    ele.hide(cookieWarning);
                    cookieWarning.style.display = "none";
                    this.createCookie("accepted", true, 365 * 10);
                });
            }
        }
    }
}



